/**
 * ResetPasswordScreen — « Nouveau mot de passe » (`password/reset/:passwordToken`), sur le design system.
 *
 * Portage de `src/auth/ResetPasswordScreen.js` : le jeton vient de la route, tout le reste de
 * `useResetPasswordState`. La route a déjà `headerShown: false` : la croix est celle de la page.
 */
import { ResetPasswordPage } from "../../../../../../design-system"
import { AuthStatusBar } from "../AuthStatusBar"
import { useResetPasswordState } from "./useResetPasswordState"

type ResetPasswordScreenProps = {
    route?: { params?: { passwordToken?: string } }
}

export function ResetPasswordScreen({ route }: ResetPasswordScreenProps) {
    const page = useResetPasswordState(route?.params?.passwordToken)
    return (
        <>
            <ResetPasswordPage {...page} />
            <AuthStatusBar />
        </>
    )
}

export default ResetPasswordScreen
